import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaWhatsapp,
  FaPhone,
  FaEnvelope,
  FaArrowRight,
} from 'react-icons/fa';
import { TbLogin2 } from 'react-icons/tb';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const contactInfo = {
    phones: [
      {
        number: '55 88 69 39 20',
        whatsapp:
          'https://wa.me/525588693920?text=¡Hola%20me%20gustaría%20ser%20parte%20del%20equipo%20Packsys!',
      },
    ],
    email: 'unete@packsys.com',
    social: [
      {
        name: 'Facebook',
        icon: <FaFacebookF />,
        href: 'https://www.facebook.com/unetepacksys',
        color: 'hover:bg-[#1877F2]',
      },
      {
        name: 'Instagram',
        icon: <FaInstagram />,
        href: 'https://www.instagram.com/unetepacksys/',
        color:
          'hover:bg-gradient-to-r from-[#833AB4] via-[#FD1D1D] to-[#FCAF45]',
      },
      {
        name: 'LinkedIn',
        icon: <FaLinkedinIn />,
        href: 'https://mx.linkedin.com/company/packsys',
        color: 'hover:bg-[#0A66C2]',
      },
    ],
  };

  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer */}
      <div className="container mx-auto px-4 py-8 md:py-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo and Description */}
          <div>
            <Link
              to="/"
              className="inline-block mb-4 flex justify-center md:justify-start"
            >
              <img
                src={'/assets/logo/logo.png'}
                alt="Packsys"
                className="h-12 sm:h-16 w-auto brightness-0 invert"
              />
            </Link>
            <div className="flex justify-center text-center md:justify-start md:text-left">
              <p className="text-gray-300 text-sm leading-relaxed mb-6 max-w-md">
                Líderes en distribución de productos para empaque y embalaje con
                más de 25 años de experiencia. Innovación, calidad y compromiso
                en cada producto.
              </p>
            </div>
            <div className="flex space-x-2 justify-center md:justify-start">
              {contactInfo.social.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`w-8 h-8 rounded-full bg-gray-800 flex items-center justify-center ${social.color} transition-all duration-300 transform hover:scale-110`}
                  aria-label={social.name}
                >
                  <span className="text-white text-sm">{social.icon}</span>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-base font-bold text-white mb-4 pb-2 border-b border-gray-800">
              Enlaces rápidos
            </h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/vacantes"
                  className="text-gray-300 hover:text-white transition-colors duration-200 flex items-center group text-sm"
                >
                  <span className="w-1 h-1 bg-primary-orange rounded-full mr-2 opacity-0 group-hover:opacity-100 transition-opacity"></span>
                  Ver vacantes
                </Link>
              </li>
              <li>
                <a
                  href="https://packsys.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white transition-colors duration-200 flex items-center group text-sm"
                >
                  <span className="w-1 h-1 bg-primary-orange rounded-full mr-2 opacity-0 group-hover:opacity-100 transition-opacity"></span>
                  Tienda Packsys
                </a>
              </li>
              <li>
                <Link
                  to="/"
                  className="text-gray-300 hover:text-white transition-colors duration-200 flex items-center group text-sm"
                >
                  <span className="w-1 h-1 bg-primary-orange rounded-full mr-2 opacity-0 group-hover:opacity-100 transition-opacity"></span>
                  Inicio
                </Link>
              </li>
            </ul>
          </div>

          {/* Información de Contacto */}
          <div>
            <h3 className="text-base font-bold text-white mb-4 pb-2 border-b border-gray-800">
              Contacto
            </h3>
            <div className="space-y-4">
              <div>
                <h4 className="text-xs font-semibold text-gray-400 mb-2">
                  Teléfono
                </h4>
                <div className="space-y-2">
                  {contactInfo.phones.map((phone) => (
                    <div key={phone.number} className="flex items-center">
                      <div className="p-1.5 bg-primary-orange/10 rounded-lg mr-2">
                        <FaPhone className="w-3.5 h-3.5 text-primary-orange" />
                      </div>
                      <div>
                        <div className="text-white text-sm font-semibold">
                          {phone.number}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div>
                <h4 className="text-xs font-semibold text-gray-400 mb-2">
                  Correo electrónico
                </h4>
                <div className="flex items-center">
                  <div className="p-1.5 bg-primary-orange/10 rounded-lg mr-2">
                    <FaEnvelope className="w-3.5 h-3.5 text-primary-orange" />
                  </div>
                  <a
                    href={`mailto:${contactInfo.email}`}
                    className="text-white text-sm font-semibold hover:text-primary-orange transition-colors duration-200"
                  >
                    {contactInfo.email}
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* WhatsApp Directo */}
          <div>
            <h3 className="text-base font-bold text-white mb-4 pb-2 border-b border-gray-800">
              WhatsApp Directo
            </h3>
            <div className="space-y-3">
              {contactInfo.phones.map((phone) => (
                <a
                  key={phone.number}
                  href={phone.whatsapp}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-between bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white font-medium py-2 px-3 rounded-lg transition-all duration-300 hover:shadow-lg text-sm"
                >
                  <span className="flex items-center">
                    <FaWhatsapp className="text-base mr-2" />
                    Mándanos un mensaje
                  </span>
                  <FaArrowRight className="w-2.5 h-2.5" />
                </a>
              ))}
            </div>
            <h3 className="text-base font-bold text-white my-4 pb-2 border-b border-gray-800">
              Administradores
            </h3>
            <div className="space-y-3">
              <a
                href="/admin/login"
                rel="noopener noreferrer"
                className="flex items-center justify-between bg-gradient-to-r from-red-500 via-orange-500 to-yellow-500 hover:from-red-700 hover:via-orange-700 hover:to-yellow-700 text-white font-medium py-2 px-3 rounded-lg transition-all duration-300 hover:shadow-lg text-sm"
              >
                <span className="flex items-center">
                  <TbLogin2 className="text-base mr-2" />
                  Inicia Sesión
                </span>
                <FaArrowRight className="w-2.5 h-2.5" />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800 bg-gray-950">
        <div className="container mx-auto px-4 py-4">
          <div className="flex flex-col md:flex-row justify-center items-center">
            <p className="text-gray-400 text-sm mb-2 md:mb-0">
              © {currentYear} Únete Packsys. Todos los derechos reservados.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
